export default "__VITE_ASSET__BMqYT5x6__"